/*=======================================================================
 * $Id: app.js 82512 2020-06-15 17:22:07Z sabri.nuzi $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2020
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

 define([
    "underscore",
    "utils/url",
    "client/resourceinfo"
   ],
   function (
     _,
     URL,
     ResourceInfo
   ) {

    function getRequestHeaders(applicationOptions, requestURL) {
      var channelHeaders = {};

      if (
        applicationOptions &&
        applicationOptions.ajaxOptions && 
        applicationOptions.ajaxOptions.requestHeaders
      ) {
        if (_.isFunction(applicationOptions.ajaxOptions.requestHeaders)) {
          channelHeaders = applicationOptions.ajaxOptions.requestHeaders(requestURL);
        } else if (_.isObject(applicationOptions.ajaxOptions.requestHeaders)){
          var urlHeadersMap = findURLMatcheByPrefix(
            applicationOptions.ajaxOptions.requestHeaders,
            requestURL
          );

          channelHeaders = applicationOptions.ajaxOptions.requestHeaders[urlHeadersMap] || {};
        }
      }

      return _.clone(channelHeaders);
    }

    /**
     * Find the first URL key which matches with a full request URL.
     * 
     * @param {*} object Map with URL keys and their header values
     * @param {*} fullURL 
     * @return {*} Found URL || null 
     */
    function findURLMatcheByPrefix(object, fullURL) {
      var urlKeys = _.keys(object);
      var urlKeyFound = false;

      for (var i = 0; i < urlKeys.length; i++) {
        if (URL.urlContains(urlKeys[i], fullURL)) {
          urlKeyFound = urlKeys[i];
          break;
        }
      }

      return urlKeyFound;
    }

    function mapBuiltInSources(applicationOptions, builtinSources, applicationSources) {
      return mapSources(applicationOptions, builtinSources, applicationSources)
    }

    function mapApplicationSources(applicationOptions, applicationSources) {
      return mapSources(applicationOptions, applicationSources);
    }
      
    function mapSources(
      applicationOptions,
      sourcesList,
      applicationSources
    ) {
        var channels = _.map(sourcesList, function(source) {
          var channel = source;
          // if applicationSources is set, it means that builtIn sources are being processed.
          if (applicationSources) {
            var foundBuiltInSourceExistInAppSources = builtInSourceExistInApplicationSources(channel, applicationSources);
            if (foundBuiltInSourceExistInAppSources) {
              // Override current builtin source if it matches any entry in sources
              source = foundBuiltInSourceExistInAppSources;
            }
          }

          if (_.isObject(source)) {
            channel = source;
            if (channel.channelType === null) { // channelType null should force channel to fallback to sourceinfo
              delete channel.channelType;
            } else if (!channel.channelType) { // if channelType not defined, use useLegacyMessageFrameChannel
              channel.channelType = applicationOptions.useLegacyMessageFrameChannel ? "MessageFrameChannel" : "CrossDomainAjaxChannel";
            }
          }

          if (_.isString(source)) {
            channel = { url: source };

            // Is entry from built in sources
            if (applicationSources) {
              channel.channelType =
                applicationOptions.useLegacyMessageFrameChannel ? 'MessageFrameChannel' : 'CrossDomainAjaxChannel';
            } else { // channel is an entry from application sources
              // Local built-in source should be initialized as CrossDomainAjaxChannel
              var localSource = ResourceInfo.scriptLocation + '../../api/v2/';
              if (localSource === source) {
                channel.channelType = 'CrossDomainAjaxChannel';
              } else {
                if (!applicationOptions.useMessageFrameForNonBuiltinSources) {
                  channel.channelType = 'CrossDomainAjaxChannel';
                } else {
                  channel.channelType = 'MessageFrameChannel';
                }
              }
            }
          }
          
          return channel;
        });

        return channels;
    }


    function builtInSourceExistInApplicationSources(builtInSource, applicationSources) {
      // Actually builtin sources are strings
      if (_.isObject(builtInSource)) {
        // Unsupported builtin source format, therefore it is considered to not match
        return false;
      }

      var foundSources = _.filter(applicationSources, function(applicationSource) {
        var sourceURL = '';
        if (_.isString(applicationSource)) {
          sourceURL = applicationSource;
        } else if (_.isObject(applicationSource)) {
          if (applicationSource.url) {
            sourceURL = applicationSource.url;
          } else {
            // Unknown application source format, therefore it is considered to not match
            return false;
          }
        } else {
          // Unknown application source format, therefore it is considered to not match
          return false;
        }

        return builtInSource === sourceURL;
      });

      return foundSources[0] || false;
    }

    /**
     * Creates a map of channels from sources
     * @param {*} builtInSources 
     * @param {*} applicationSources 
     * @return object {builtInChannels, applicationChannels}
     */
    function mapSourcesToChannels(applicationOptions, builtInSources, applicationSources) {
      var builtInChannels = mapBuiltInSources(applicationOptions, builtInSources, applicationSources);
      var applicationChannels = mapApplicationSources(applicationOptions, applicationSources);

      return {
        builtInChannels: builtInChannels,
        applicationChannels: applicationChannels
      };
    }
 
    function getRootElement(rootEls, el) {
      var rootEl = rootEls;
      if (Array.isArray(rootEl)) {
        rootEl = _.filter(rootEl, function(_rootEl) {
          return _rootEl.contains(el);
        });
      }

      return rootEl || document.documentElement;
    }
 
    return {
      getRequestHeaders: getRequestHeaders,
      mapSourcesToChannels: mapSourcesToChannels,
      getRootElement: getRootElement,
      mapApplicationSources: mapApplicationSources
    }
})
